export default {
    GET_USER_DATA: "GET_USER_DATA",
    GET_MEMBER_TABLE_DATA: "GET_MEMBER_TABLE_DATA"
}